<template>
  <drag-dialog
    title="新增客户"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :defaultTop="150"
    :defaultLeft="620"
    :submit="submit"
    :cancel="cancel"
    class="addCustomer">
    <el-form
      class="form publice-form-primary"
      :model="form"
      :rules="rules"
      label-width="90px"
      ref="form">
      <el-form-item
        label="客户单位:"
        prop="companyName">
        <el-input
          class="input-primary"
          v-model="form.companyName"
          placeholder="请输入客户单位名称">
        </el-input>
      </el-form-item>
      <el-form-item
        label="对接人:"
        prop="contact">
        <el-input
          class="input-primary"
          v-model="form.contact"
          placeholder="请输入对接人姓名"></el-input>
      </el-form-item>
      <el-form-item
        label="职位"
        prop="contactPosition">
        <el-input
          class="input-primary"
          v-model="form.contactPosition"
          placeholder="请输入职位"></el-input>
      </el-form-item>
      <el-form-item
        label="手机号:"
        prop="mobile">
        <el-input
          class="input-primary"
          v-model="form.mobile"
          placeholder="请输入客户联系方式"></el-input>
      </el-form-item>
      <el-form-item label="邮箱:">
        <el-input
          class="input-primary"
          v-model="form.email"
          placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="微信:">
        <el-input
          class="input-primary"
          v-model="form.weChat"
          placeholder="请输入客户微信号">
        </el-input>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input
          class="input-primary"
          type="textarea"
          placeholder="请输入客户信息简介"
          maxlength="200"
          :autosize="{ minRows: 5, maxRows: 8 }"
          show-word-limit
          v-model="form.remarks"></el-input>
      </el-form-item>
    </el-form>
  </drag-dialog>
</template>

<script>
import dragDialog from '@/components/DragDialog.vue'

import { createPrivateConfig } from '@/service/interface'

export default {
  data() {
    return {
      form: {
        companyName: '',
        contact: '',
        contactPosition: '',
        mobile: '',
        email: '',
        weChat: '',
        remarks: ''
      },
      rules: {
        companyName: [
          {
            required: true,
            message: '请输入客户单位名称',
            trigger: 'blur'
          },
          {
            pattern: /^\S*$/g,
            message: '禁止输入空格',
            trigger: 'change'
          }
        ],
        contactPosition: [
          {
            required: true,
            message: '请输入客户职位',
            trigger: 'blur'
          },
          {
            pattern: /^\S*$/g,
            message: '禁止输入空格',
            trigger: 'change'
          }
        ],
        contact: [
          {
            required: true,
            message: '请输入对接人',
            trigger: 'blur'
          },
          {
            pattern: /^\S*$/g,
            message: '禁止输入空格',
            trigger: 'change'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: '请输入合法的手机号码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
    queryCustomerList: Function
  },
  components: {
    dragDialog
  },
  methods: {
    submit() {
      this.$refs.form.validate((bool, object) => {
        if (bool) {
          createPrivateConfig(this.form).then(response => {
            if (response.isSuccess) {
              this.queryCustomerList(response.id).then(() => {
                this.$message.success('新建客户成功！！！')
                this.cancel()
              })
            }
          })
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    cancel() {
      this.form = {
        companyName: '',
        contact: '',
        contactPosition: '',
        mobile: '',
        email: '',
        weChat: '',
        remarks: ''
      }
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  :deep(.el-form-item) {
    margin-bottom: 18px;
    height: 32px;
    .el-input__inner {
      height: 32px;
    }

    .el-form-item__label{
      line-height: 32px;
    }

    .el-form-item__content{
      line-height: 32px;
    }

    .el-form-item__error {
      padding-top: 4px !important;
    }

    & {
      margin-bottom: 26px;
    }
  }
}

.addCustomer {
  :deep(.dialog-content) {
    overflow-y: auto;
    margin-bottom: 16px;
  }

  :deep(.dialog) {
    // height: 600px;
  }
}
</style>
